import React from 'react';

type Props = {};

function InvoiceData({}: Props) {
  return <div>InvoiceData Test</div>;
}

export default InvoiceData;
